import { entries } from "./objects";
import { isUndefined } from "./identity";
import { sortBy } from "./arrays";

export const toQuery = (
  data: Record<string, any> = {},
  endpoint?: string
): string => {
  const parameters = new URLSearchParams();
  const sortedParameters = sortBy(entries(data), 0);
  for (const [key, value] of sortedParameters) {
    if (isUndefined(value)) {
      continue;
    }

    if (Array.isArray(value) && value.length === 0) {
      if (endpoint) {
        console.trace(`toQuery: empty array passed as ${key} to ${endpoint}`);
      } else {
        console.trace(`toQuery: empty array passed as ${key}`);
      }
    }

    parameters.append(key, String(value));
  }
  if ([...parameters.keys()].length === 0) {
    return "";
  }
  return `${parameters.toString()}`;
};
